<template>
  <div>
    <el-button
      type="warning"
      @click="printHtml">
      更多<i class="el-icon-arrow-down el-icon--right"></i>
    </el-button>
    <printer-select-modal ref="printer" />
  </div>
</template>

<script>
import PrinterSelectModal from './busi/printer-select-modal.vue'
import HTML from './html.js'
export default {
  name: 'PrintTest',
  components: { PrinterSelectModal },
  methods: {
    printHtml() {
      this.$refs.printer.fetch([{
        printTemplate: HTML
      }])
    }
  }
}
</script>

<style>

</style>
